import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

const StockOutPage = () => {
  const [stockOuts, setStockOuts] = useState([]);
  const [items, setItems] = useState([]);
  const [branches] = useState(["Lehulu", "Kalkidan", "Store"]);
  const [categories, setCategories] = useState([]);
  const [filters, setFilters] = useState({
    branch: "",
    category: "",
    search: "",
    specificDate: "",
    startDate: "",
    endDate: "",
    monthYear: "",
  });
  const [formData, setFormData] = useState({
    item: null,
    quantity: "",
    unitprice: "",
    note: "",
    personName: "",
    for_who: "",
    from: "",
    for_what: "",
  });
  const [editingId, setEditingId] = useState(null);
  const [isItemModalOpen, setIsItemModalOpen] = useState(false);
  const [itemFilters, setItemFilters] = useState({
    branch: "",
    category: "",
    search: "",
    reserve_for_branch: "",
  });
  const [isLoading, setIsLoading] = useState({
    submit: false,
    cancel: false,
    selectItem: false,
    closeModal: false,
    edit: false,
    delete: false,
    openModal: false,
    transfer: false,
  });
  const [showFilters, setShowFilters] = useState(false);
  const [showTransferModal, setShowTransferModal] = useState(false);
  const [transferData, setTransferData] = useState({
    from: "",
    forWhat: "",
    transferDate: "",
    stockOutId: null,
  });
  const [viewingItem, setViewingItem] = useState(null);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editFormData, setEditFormData] = useState({
    item: null,
    quantity: "",
    unitprice: "",
    note: "",
    personName: "",
    for_who: "",
    from: "",
    for_what: "",
  });

  useEffect(() => {
    fetchStockOuts();
    fetchItems();
    fetchCategories();
  }, [
    filters.branch,
    filters.category,
    filters.search,
    filters.specificDate,
    filters.startDate,
    filters.endDate,
    filters.monthYear,
    itemFilters.branch,
    itemFilters.category,
    itemFilters.search,
    itemFilters.reserve_for_branch,
  ]);

  const fetchStockOuts = async () => {
    try {
      let url = filters.branch
        ? `https://backend.lehuluet.com/api/stockouts/stockouts/by-branch/${filters.branch}`  // FIXED: correct URL
        : "https://backend.lehuluet.com/api/stockouts/stockouts";

      const queryParams = [];

      if (filters.specificDate) {
        queryParams.push(`specificDate=${filters.specificDate}`);
      } else if (filters.startDate && filters.endDate) {
        queryParams.push(`startDate=${filters.startDate}`);
        queryParams.push(`endDate=${filters.endDate}`);
      } else if (filters.monthYear) {
        queryParams.push(`monthYear=${filters.monthYear}`);
      }

      if (queryParams.length > 0) {
        url += `?${queryParams.join("&")}`;
      }

      const response = await axios.get(url);
      setStockOuts(response.data.data);
    } catch (error) {
      toast.error("Error fetching stock-outs");
    }
  };

  const fetchItems = async () => {
    try {
      const url = itemFilters.branch
        ? `https://backend.lehuluet.com/api/items/items/branch/${itemFilters.branch}`
        : "https://backend.lehuluet.com/api/items/items";
      const response = await axios.get(url);
      let filteredData = response.data.data;

      // FIXED: Use item.category?.id instead of item.category?._id
      if (itemFilters.category) {
        filteredData = filteredData.filter((item) => {
          const categoryId = item.category?.id ? item.category.id : item.categoryId;
          return categoryId === parseInt(itemFilters.category);
        });
      }
      if (itemFilters.search) {
        const searchLower = itemFilters.search.toLowerCase();
        filteredData = filteredData.filter(
          (item) =>
            (item.name && item.name.toLowerCase().includes(searchLower)) ||
            (item.brand && item.brand.toLowerCase().includes(searchLower))
        );
      }
      if (itemFilters.reserve_for_branch) {
        filteredData = filteredData.filter(
          (item) => item.reserve_for_branch === itemFilters.reserve_for_branch
        );
      }

      setItems(filteredData);
    } catch (error) {
      toast.error("Error fetching items");
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await axios.get(
        "https://backend.lehuluet.com/api/categories/categories"
      );
      setCategories(response.data.data);
    } catch (error) {
      toast.error("Error fetching categories");
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;

    if (name === "specificDate" || name === "monthYear") {
      setFilters({
        ...filters,
        [name]: value,
        startDate: "",
        endDate: "",
        ...(name === "specificDate" && { monthYear: "" }),
        ...(name === "monthYear" && { specificDate: "" }),
      });
    } else {
      setFilters({ ...filters, [name]: value });
    }
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleEditInputChange = (e) => {
    setEditFormData({ ...editFormData, [e.target.name]: e.target.value });
  };

  const handleItemFilterChange = (e) => {
    setItemFilters({ ...itemFilters, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.item) {
      toast.error("Please select an item");
      return;
    }
    setIsLoading((prev) => ({ ...prev, submit: true }));
    try {
      const submitData = {
        item: formData.item.id,  // FIXED: use item.id instead of item._id
        quantity: formData.quantity,
        unitprice: formData.unitprice,
        note: formData.note,
        for_who: formData.for_who,
        from: formData.from,
        for_what: formData.for_what,
      };
      const token = localStorage.getItem("token");
      await axios.post(
        "https://backend.lehuluet.com/api/stockouts/stockouts",
        submitData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      toast.success("Stock-out created successfully");
      fetchStockOuts();
      resetForm();
    } catch (error) {
      toast.error(error.response?.data?.message || "Error saving stock-out");
    } finally {
      setIsLoading((prev) => ({ ...prev, submit: false }));
    }
  };

  const handleEdit = (stockOut) => {
    setIsLoading((prev) => ({ ...prev, edit: true }));
    setEditingId(stockOut.id);  // FIXED: use stockOut.id instead of stockOut._id
    setEditFormData({
      item: stockOut.item,
      quantity: stockOut.quantity || "",
      unitprice: stockOut.unitprice || "",
      note: stockOut.note || "",
      personName: stockOut.personName || "",
      for_who: stockOut.for_who || "",
      from: stockOut.from || "",
      for_what: stockOut.for_what || "",
    });
    setIsEditModalOpen(true);
    setIsLoading((prev) => ({ ...prev, edit: false }));
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    if (!editFormData.item) {
      toast.error("Please select an item");
      return;
    }
    setIsLoading((prev) => ({ ...prev, submit: true }));
    try {
      const submitData = {
        item: editFormData.item.id,  // FIXED: use item.id instead of item._id
        quantity: editFormData.quantity,
        unitprice: editFormData.unitprice,
        note: editFormData.note,
        for_who: editFormData.for_who,
        from: editFormData.from,
        for_what: editFormData.for_what,
      };
      const token = localStorage.getItem("token");
      await axios.put(
        `https://backend.lehuluet.com/api/stockouts/stockouts/${editingId}`,
        submitData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      toast.success("Stock-out updated successfully");
      fetchStockOuts();
      setIsEditModalOpen(false);
      setEditingId(null);
      setEditFormData({
        item: null,
        quantity: "",
        unitprice: "",
        note: "",
        personName: "",
        for_who: "",
        from: "",
        for_what: "",
      });
    } catch (error) {
      toast.error(error.response?.data?.message || "Error updating stock-out");
    } finally {
      setIsLoading((prev) => ({ ...prev, submit: false }));
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this stock-out?")) {
      setIsLoading((prev) => ({ ...prev, delete: true }));
      try {
        const token = localStorage.getItem("token");
        await axios.delete(
          `https://backend.lehuluet.com/api/stockouts/stockouts/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        toast.success("Stock-out deleted successfully");
        fetchStockOuts();
      } catch (error) {
        toast.error(error.response?.data?.error || "Error deleting stock-out");
      } finally {
        setIsLoading((prev) => ({ ...prev, delete: false }));
      }
    }
  };

  const handleTransfer = (stockOut) => {
    setTransferData({
      from: stockOut.from || "",
      forWhat: stockOut.for_what || "",
      transferDate: stockOut.transfer_date || "",
      stockOutId: stockOut.id,  // FIXED: use stockOut.id
    });
    setShowTransferModal(true);
  };

  const confirmTransfer = async () => {
    const token = localStorage.getItem("token");

    if (!transferData.from || !transferData.forWhat || !transferData.transferDate) {
      toast.error("Please fill in all transfer details");
      return;
    }

    setIsLoading((prev) => ({ ...prev, transfer: true }));

    try {
      await axios.put(
        `https://backend.lehuluet.com/api/stockouts/stockouts/${transferData.stockOutId}`,
        {
          from: transferData.from,
          for_what: transferData.forWhat,
          transfer_date: transferData.transferDate,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      toast.success("Transfer updated successfully");
      fetchStockOuts();
      setShowTransferModal(false);
      setTransferData({
        from: "",
        forWhat: "",
        transferDate: "",
        stockOutId: null,
      });
    } catch (error) {
      toast.error(error.response?.data?.message || "Error updating transfer");
      console.error("Transfer update error:", error);
    } finally {
      setIsLoading((prev) => ({ ...prev, transfer: false }));
    }
  };

  const resetForm = () => {
    setIsLoading((prev) => ({ ...prev, cancel: true }));
    setFormData({
      item: null,
      quantity: "",
      unitprice: "",
      note: "",
      personName: "",
      for_who: "",
      from: "",
      for_what: "",
    });
    setEditingId(null);
    setIsLoading((prev) => ({ ...prev, cancel: false }));
  };

  const filteredStockOuts = stockOuts.filter((stockOut) => {
    const stockOutDate = new Date(stockOut.created_at);
    // FIXED: Use category.id instead of category._id
    const matchesCategory = filters.category
      ? (stockOut.item?.category?.id || stockOut.item?.categoryId) ===
        parseInt(filters.category)
      : true;
    const matchesSearch = filters.search
      ? stockOut.item?.name
          ?.toLowerCase()
          .includes(filters.search.toLowerCase()) ||
        stockOut.item?.brand
          ?.toLowerCase()
          .includes(filters.search.toLowerCase())
      : true;

    let matchesDate = true;

    if (filters.specificDate) {
      const specificDate = new Date(filters.specificDate);
      matchesDate = stockOutDate.toDateString() === specificDate.toDateString();
    } else if (filters.startDate && filters.endDate) {
      const start = new Date(filters.startDate);
      const end = new Date(filters.endDate);
      end.setHours(23, 59, 59, 999);
      matchesDate = stockOutDate >= start && stockOutDate <= end;
    } else if (filters.monthYear) {
      const [year, month] = filters.monthYear.split("-");
      matchesDate =
        stockOutDate.getFullYear() === parseInt(year) &&
        stockOutDate.getMonth() === parseInt(month) - 1;
    }

    return matchesCategory && matchesSearch && matchesDate;
  });

  const selectItem = (item) => {
    setIsLoading((prev) => ({ ...prev, selectItem: true }));
    setFormData({ ...formData, item });
    setIsItemModalOpen(false);
    setItemFilters({
      branch: "",
      category: "",
      search: "",
      reserve_for_branch: "",
    });
    setIsLoading((prev) => ({ ...prev, selectItem: false }));
  };

  const openModal = () => {
    setIsLoading((prev) => ({ ...prev, openModal: true }));
    setIsItemModalOpen(true);
    fetchItems();
    setIsLoading((prev) => ({ ...prev, openModal: false }));
  };

  const closeModal = () => {
    setIsLoading((prev) => ({ ...prev, closeModal: true }));
    setIsItemModalOpen(false);
    setIsLoading((prev) => ({ ...prev, closeModal: false }));
  };

  const openViewModal = (stockOut) => {
    setViewingItem(stockOut);
    setIsViewModalOpen(true);
  };

  const closeViewModal = () => {
    setIsViewModalOpen(false);
    setViewingItem(null);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setEditingId(null);
    setEditFormData({
      item: null,
      quantity: "",
      unitprice: "",
      note: "",
      personName: "",
      for_who: "",
      from: "",
      for_what: "",
    });
  };

  const exportToCSV = () => {
    if (!filteredStockOuts.length) return;

    const headers = [
      "Date",
      "Brand",
      "Branch",
      "Category",
      "Size",
      "UniqueSize / AMP",
      "Position / Origin",
      "Quantity",
      "Unit Price",
      "Total",
      "Note",
      "Person",
    ];
    const rows = filteredStockOuts.map((stockOut) => [
      stockOut.created_at
        ? new Date(stockOut.created_at).toLocaleDateString()
        : "N/A",
      stockOut.item?.brand || "N/A",
      stockOut.item?.branch || "N/A",
      stockOut.item?.category?.name || "N/A",
      stockOut.item?.size || "N/A",
      stockOut.item?.uniquesize || stockOut.item?.ampere || "N/A",
      stockOut.item?.position || stockOut.item?.origin || "N/A",
      stockOut.quantity || 0,
      stockOut.unitprice || 0,
      (stockOut.quantity * stockOut.unitprice || 0).toFixed(2),
      stockOut.note || "----",
      stockOut.user?.name || "-",
    ]);

    const csvContent = [
      headers.join(","),
      ...rows.map((row) => row.map((cell) => `"${cell}"`).join(",")),
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "stock_outs.csv";
    link.click();
    URL.revokeObjectURL(link.href);
  };

  return (
    <div className="container mx-auto p-4">
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-4 gap-4">
        <h1 className="text-2xl text-teal-700 font-bold">
          Stock Out Management
        </h1>
        <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
          <button
            onClick={() => setShowFilters(!showFilters)}
            className="w-full sm:w-auto px-4 py-2 bg-teal-500 text-white rounded hover:bg-teal-600"
          >
            {showFilters ? "Hide Filters" : "Show Filters"}
          </button>
          <button
            onClick={exportToCSV}
            className="w-full sm:w-auto px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
          >
            Export to CSV
          </button>
        </div>
      </div>

      {showFilters && (
        <div className="bg-gray-100 p-4 rounded-lg shadow-sm mb-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
            <div>
              <label className="block text-gray-700 mb-1">Branch</label>
              <select
                name="branch"
                value={filters.branch}
                onChange={handleFilterChange}
                className="w-full p-2 border rounded"
              >
                <option value="">All Branches</option>
                {branches.map((branch) => (
                  <option key={branch} value={branch}>
                    {branch}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-gray-700 mb-1">Category</label>
              <select
                name="category"
                value={filters.category}
                onChange={handleFilterChange}
                className="w-full p-2 border rounded"
              >
                <option value="">All Categories</option>
                {categories.map((category) => (
                  <option key={category.id} value={category.id}>  {/* FIXED: use category.id */}
                    {category.name}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-gray-700 mb-1">Search</label>
              <input
                type="text"
                name="search"
                value={filters.search}
                onChange={handleFilterChange}
                placeholder="Search by name or brand..."
                className="w-full p-2 border rounded"
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <label className="block text-gray-700 mb-1">Specific Date</label>
              <input
                type="date"
                name="specificDate"
                value={filters.specificDate}
                onChange={handleFilterChange}
                className="w-full p-2 border rounded"
              />
            </div>

            <div>
              <label className="block text-gray-700 mb-1">Start Date</label>
              <input
                type="date"
                name="startDate"
                value={filters.startDate}
                onChange={handleFilterChange}
                className="w-full p-2 border rounded"
              />
            </div>

            <div>
              <label className="block text-gray-700 mb-1">End Date</label>
              <input
                type="date"
                name="endDate"
                value={filters.endDate}
                onChange={handleFilterChange}
                className="w-full p-2 border rounded"
              />
            </div>

            <div>
              <label className="block text-gray-700 mb-1">Month/Year</label>
              <input
                type="month"
                name="monthYear"
                value={filters.monthYear}
                onChange={handleFilterChange}
                className="w-full p-2 border rounded"
              />
            </div>
          </div>
        </div>
      )}

      <form onSubmit={handleSubmit} className="bg-gray-100 p-4 rounded mb-6">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
          <div className="w-full">
            <button
              type="button"
              onClick={openModal}
              disabled={isLoading.openModal}
              className="w-full flex items-center justify-between px-4 py-3 border rounded-lg bg-white text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200 shadow-sm"
            >
              <span className="truncate">
                {isLoading.openModal
                  ? "Loading..."
                  : formData.item
                  ? `${formData.item.name} - ${formData.item.brand}`
                  : "Select Item"}
              </span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-5 h-5 text-gray-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </button>
          </div>

          <input
            type="number"
            name="quantity"
            value={formData.quantity}
            onChange={handleInputChange}
            placeholder="Quantity"
            className="w-full p-2 border rounded"
            required
            min="1"
          />

          <input
            type="number"
            name="unitprice"
            value={formData.unitprice}
            onChange={handleInputChange}
            placeholder="Unit Price"
            className="w-full p-2 border rounded"
            required
            min="0"
            step="0.01"
          />

          <input
            type="number"
            name="total"
            value={formData.quantity * formData.unitprice || 0}
            placeholder="Total"
            className="w-full p-2 border rounded bg-gray-100"
            readOnly
          />

          <input
            type="text"
            name="note"
            value={formData.note}
            onChange={handleInputChange}
            placeholder="Note (optional)"
            className="w-full p-2 border rounded"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
          <input
            type="text"
            name="for_who"
            value={formData.for_who}
            onChange={handleInputChange}
            placeholder="ወደ ማን ገባ ብሩ"
            className="w-full p-2 border rounded"
            required
          />

          <input
            type="text"
            name="date"
            value={new Date().toLocaleDateString()}
            placeholder="Date"
            className="w-full p-2 border rounded bg-gray-100"
            readOnly
          />
          
          <div className="flex gap-2">
            <button
              type="submit"
              disabled={isLoading.submit}
              className="bg-teal-500 text-white px-4 py-2 rounded hover:bg-teal-600 disabled:opacity-50"
            >
              {isLoading.submit ? "Loading..." : "Create"} Stock-Out
            </button>
            {editingId && (
              <button
                type="button"
                onClick={resetForm}
                disabled={isLoading.cancel}
                className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600 disabled:opacity-50"
              >
                {isLoading.cancel ? "Loading..." : "Cancel"}
              </button>
            )}
          </div>
        </div>
      </form>

      {isItemModalOpen && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center">
          <div className="bg-white p-6 rounded-lg w-full max-w-2xl">
            <h2 className="text-xl font-bold mb-4">Select Item</h2>

            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4">
              <div>
                <label className="block text-gray-700 mb-1">Branch</label>
                <select
                  name="branch"
                  value={itemFilters.branch}
                  onChange={handleItemFilterChange}
                  className="w-full p-2 border rounded"
                >
                  <option value="">All Branches</option>
                  {branches.map((branch) => (
                    <option key={branch} value={branch}>
                      {branch}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-gray-700 mb-1">
                  Reserve for Branch
                </label>
                <select
                  name="reserve_for_branch"
                  value={itemFilters.reserve_for_branch}
                  onChange={handleItemFilterChange}
                  className="w-full p-2 border rounded"
                >
                  <option value="">All Branches</option>
                  {branches.map((branch) => (
                    <option key={branch} value={branch}>
                      {branch}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-gray-700 mb-1">Category</label>
                <select
                  name="category"
                  value={itemFilters.category}
                  onChange={handleItemFilterChange}
                  className="w-full p-2 border rounded"
                >
                  <option value="">All Categories</option>
                  {categories.map((category) => (
                    <option key={category.id} value={category.id}>  {/* FIXED: use category.id */}
                      {category.name}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-gray-700 mb-1">Search</label>
                <input
                  type="text"
                  name="search"
                  value={itemFilters.search}
                  onChange={handleItemFilterChange}
                  placeholder="Search items..."
                  className="w-full p-2 border rounded"
                />
              </div>
            </div>

            <div className="max-h-64 overflow-y-auto">
              <table className="w-full">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="p-2 text-left">Category</th>
                    <th className="p-2 text-left">Brand</th>
                    <th className="p-2 text-left">Size</th>
                    <th className="p-2 text-left">Postion/Orgin</th>
                    <th className="p-2 text-left">UniqueSize/AMP</th>
                    <th className="p-2 text-left">Available</th>
                    <th className="p-2 text-left">Reserve for Branch</th>
                    <th className="p-2 text-left">Branch</th>
                    <th className="p-2 text-left">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((item) => (
                    <tr key={item.id} className="border-b hover:bg-gray-50">  {/* FIXED: use item.id */}
                      <td className="p-2">{item.category?.name}</td>
                      <td className="p-2">{item.brand}</td>
                      <td className="p-2">{item.size}</td>
                      <td className="p-2">{item.position || item.origin}</td>
                      <td className="p-2">{item.uniquesize || item.ampere}</td>
                      <td className="p-2">{item.quantity}</td>
                      <td className="p-2">{item.reserve_for_branch}</td>
                      <td className="p-2">{item.branch}</td>
                      <td className="p-2 flex gap-2">
                        <button
                          onClick={() => selectItem(item)}
                          disabled={isLoading.selectItem || item.quantity <= 0}
                          className="bg-green-500 text-white px-2 py-1 rounded hover:bg-green-600 disabled:opacity-50"
                        >
                          {isLoading.selectItem ? "Loading..." : "Select"}
                        </button>
                        <button
                          onClick={() => openViewModal(item)}
                          className="bg-teal-500 text-white px-2 py-1 rounded hover:bg-teal-600"
                        >
                          View
                        </button>
                       </td>
                     </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <button
              onClick={closeModal}
              disabled={isLoading.closeModal}
              className="mt-4 bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600 disabled:opacity-50"
            >
              {isLoading.closeModal ? "Loading..." : "Close"}
            </button>
          </div>
        </div>
      )}

      {isEditModalOpen && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center">
          <div className="bg-white p-6 rounded-lg w-full max-w-2xl">
            <h2 className="text-xl font-bold mb-4">Edit Stock-Out</h2>
            <form onSubmit={handleEditSubmit}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-gray-700 mb-1">Item</label>
                  <input
                    type="text"
                    value={
                      editFormData.item
                        ? `${editFormData.item.name} - ${editFormData.item.brand}`
                        : "N/A"
                    }
                    className="w-full p-2 border rounded bg-gray-100"
                    readOnly
                  />
                </div>
                <div>
                  <label className="block text-gray-700 mb-1">Quantity</label>
                  <input
                    type="number"
                    name="quantity"
                    value={editFormData.quantity}
                    onChange={handleEditInputChange}
                    placeholder="Quantity"
                    className="w-full p-2 border rounded"
                    required
                    min="1"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 mb-1">
                    Unit Price
                  </label>
                  <input
                    type="number"
                    name="unitprice"
                    value={editFormData.unitprice}
                    onChange={handleEditInputChange}
                    placeholder="Unit Price"
                    className="w-full p-2 border rounded"
                    required
                    min="0"
                    step="0.01"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 mb-1">Total</label>
                  <input
                    type="number"
                    value={editFormData.quantity * editFormData.unitprice || 0}
                    placeholder="Total"
                    className="w-full p-2 border rounded bg-gray-100"
                    readOnly
                  />
                </div>
                <div>
                  <label className="block text-gray-700 mb-1">Note</label>
                  <input
                    type="text"
                    name="note"
                    value={editFormData.note}
                    onChange={handleEditInputChange}
                    placeholder="Note (optional)"
                    className="w-full p-2 border rounded"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 mb-1">For Who</label>
                  <input
                    type="text"
                    name="for_who"
                    value={editFormData.for_who}
                    onChange={handleEditInputChange}
                    placeholder="For Who"
                    className="w-full p-2 border rounded"
                    required
                  />
                </div>
                <div>
                  <label className="block text-gray-700 mb-1">From</label>
                  <input
                    type="text"
                    name="from"
                    value={editFormData.from}
                    onChange={handleEditInputChange}
                    placeholder="From"
                    className="w-full p-2 border rounded"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 mb-1">For What</label>
                  <input
                    type="text"
                    name="for_what"
                    value={editFormData.for_what}
                    onChange={handleEditInputChange}
                    placeholder="For What"
                    className="w-full p-2 border rounded"
                  />
                </div>
              </div>
              <div className="mt-4 flex gap-2 justify-end">
                <button
                  type="button"
                  onClick={closeEditModal}
                  className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={isLoading.submit}
                  className="bg-teal-500 text-white px-4 py-2 rounded hover:bg-teal-600 disabled:opacity-50"
                >
                  {isLoading.submit ? "Loading..." : "Update"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {showTransferModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-white p-6 rounded-lg w-96">
            <h2 className="text-lg font-bold mb-4">Transfer Details</h2>

            <div className="mb-4">
              <label className="block mb-1">From:</label>
              <input
                type="text"
                value={transferData.from}
                onChange={(e) =>
                  setTransferData({
                    ...transferData,
                    from: e.target.value,
                  })
                }
                className="w-full p-2 border rounded"
                placeholder="ብሩን የላከው ስም"
              />
            </div>

            <div className="mb-4">
              <label className="block mb-1">For what:</label>
              <input
                type="text"
                value={transferData.forWhat}
                onChange={(e) =>
                  setTransferData({
                    ...transferData,
                    forWhat: e.target.value,
                  })
                }
                className="w-full p-2 border rounded"
                placeholder="ለማን ላከ"
              />
            </div>

            <div className="mb-4">
              <label className="block mb-1">Transfer Date:</label>
              <input
                type="date"
                value={transferData.transferDate || ""}
                onChange={(e) =>
                  setTransferData({
                    ...transferData,
                    transferDate: e.target.value,
                  })
                }
                className="w-full p-2 border rounded"
                required
              />
            </div>

            <div className="flex justify-end gap-2">
              <button
                type="button"
                onClick={() => setShowTransferModal(false)}
                className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={confirmTransfer}
                disabled={
                  isLoading.transfer ||
                  !transferData.from ||
                  !transferData.forWhat ||
                  !transferData.transferDate
                }
                className="bg-teal-500 text-white px-4 py-2 rounded hover:bg-teal-600 disabled:opacity-50"
              >
                {isLoading.transfer ? "Loading..." : "Confirm"}
              </button>
            </div>
          </div>
        </div>
      )}

      {isViewModalOpen && viewingItem && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center">
          <div className="bg-white p-6 rounded-lg w-full max-w-3xl">
            <h2 className="text-xl font-bold mb-4">
              {viewingItem.quantity && viewingItem.unitprice
                ? "Stock-Out Details"
                : "Item Details"}
            </h2>
            {viewingItem.quantity && viewingItem.unitprice ? (
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div>
                  <h3 className="font-semibold text-lg mb-2">Stock-Out Info</h3>
                  <div className="space-y-2">
                    {viewingItem.quantity && (
                      <p>
                        <span className="font-medium">Quantity:</span>{" "}
                        {viewingItem.quantity}
                      </p>
                    )}
                    {viewingItem.unitprice && (
                      <p>
                        <span className="font-medium">Unit Price:</span> $
                        {viewingItem.unitprice}
                      </p>
                    )}
                    {viewingItem.quantity && viewingItem.unitprice && (
                      <p>
                        <span className="font-medium">Total:</span> $
                        {(viewingItem.quantity * viewingItem.unitprice).toFixed(
                          2
                        )}
                      </p>
                    )}
                    {viewingItem.note && (
                      <p>
                        <span className="font-medium">Note:</span>{" "}
                        {viewingItem.note}
                      </p>
                    )}
                    {viewingItem.for_who && (
                      <p>
                        <span className="font-medium">For Who:</span>{" "}
                        {viewingItem.for_who}
                      </p>
                    )}
                    {viewingItem.from && (
                      <p>
                        <span className="font-medium">From:</span>{" "}
                        {viewingItem.from}
                      </p>
                    )}
                    <p>
                      <span className="font-medium">From Branch:</span>{" "}
                      {viewingItem.fromBranch || "N/A"}
                    </p>
                    {viewingItem.for_what && (
                      <p>
                        <span className="font-medium">For What:</span>{" "}
                        {viewingItem.for_what}
                      </p>
                    )}
                    {viewingItem.transfer_date && (
                      <p>
                        <span className="font-medium">Transfer Date:</span>{" "}
                        {new Date(viewingItem.transfer_date).toLocaleString()}
                      </p>
                    )}
                    {viewingItem.created_at && (
                      <p>
                        <span className="font-medium">Date:</span>{" "}
                        {new Date(viewingItem.created_at).toLocaleString()}
                      </p>
                    )}
                  </div>
                </div>

                <div>
                  <h3 className="font-semibold text-lg mb-2">Item Info</h3>
                  <div className="space-y-2">
                    {viewingItem.item?.name && (
                      <p>
                        <span className="font-medium">Name:</span>{" "}
                        {viewingItem.item.name}
                      </p>
                    )}
                    {viewingItem.item?.brand && (
                      <p>
                        <span className="font-medium">Brand:</span>{" "}
                        {viewingItem.item.brand}
                      </p>
                    )}
                    {viewingItem.item?.branch && (
                      <p>
                        <span className="font-medium">Branch:</span>{" "}
                        {viewingItem.item.branch}
                      </p>
                    )}
                    {viewingItem.item?.size && (
                      <p>
                        <span className="font-medium">Size:</span>{" "}
                        {viewingItem.item.size}
                      </p>
                    )}
                    {viewingItem.item?.uniquesize && (
                      <p>
                        <span className="font-medium">Unique Size:</span>{" "}
                        {viewingItem.item.uniquesize}
                      </p>
                    )}
                    {viewingItem.item?.ampere && (
                      <p>
                        <span className="font-medium">Ampere:</span>{" "}
                        {viewingItem.item.ampere}
                      </p>
                    )}
                    {viewingItem.item?.position && (
                      <p>
                        <span className="font-medium">Position:</span>{" "}
                        {viewingItem.item.position}
                      </p>
                    )}
                    {viewingItem.item?.origin && (
                      <p>
                        <span className="font-medium">Origin:</span>{" "}
                        {viewingItem.item.origin}
                      </p>
                    )}
                    {viewingItem.item?.reserve_for_branch && (
                      <p>
                        <span className="font-medium">Reserve for Branch:</span>{" "}
                        {viewingItem.item.reserve_for_branch}
                      </p>
                    )}
                    {viewingItem.item?.category?.name && (
                      <p>
                        <span className="font-medium">Category:</span>{" "}
                        {viewingItem.item.category.name}
                      </p>
                    )}
                  </div>
                </div>

                <div>
                  <h3 className="font-semibold text-lg mb-2">User Info</h3>
                  <div className="space-y-2">
                    {viewingItem.user?.name && (
                      <p>
                        <span className="font-medium">Name:</span>{" "}
                        {viewingItem.user.name}
                      </p>
                    )}
                    {viewingItem.user?.email && (
                      <p>
                        <span className="font-medium">Email:</span>{" "}
                        {viewingItem.user.email}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <h3 className="font-semibold">Basic Information</h3>
                  <div className="mt-2 space-y-2">
                    {viewingItem.name && (
                      <p>
                        <span className="font-medium">Name:</span>{" "}
                        {viewingItem.name}
                      </p>
                    )}
                    {viewingItem.brand && (
                      <p>
                        <span className="font-medium">Brand:</span>{" "}
                        {viewingItem.brand}
                      </p>
                    )}
                    {viewingItem.branch && (
                      <p>
                        <span className="font-medium">Branch:</span>{" "}
                        {viewingItem.branch}
                      </p>
                    )}
                    {viewingItem.quantity && (
                      <p>
                        <span className="font-medium">Quantity:</span>{" "}
                        {viewingItem.quantity}
                      </p>
                    )}
                  </div>
                </div>
                <div>
                  <h3 className="font-semibold">Additional Details</h3>
                  <div className="mt-2 space-y-2">
                    {viewingItem.size && (
                      <p>
                        <span className="font-medium">Size:</span>{" "}
                        {viewingItem.size}
                      </p>
                    )}
                    {viewingItem.uniquesize && (
                      <p>
                        <span className="font-medium">Unique Size:</span>{" "}
                        {viewingItem.uniquesize}
                      </p>
                    )}
                    {viewingItem.ampere && (
                      <p>
                        <span className="font-medium">Ampere:</span>{" "}
                        {viewingItem.ampere}
                      </p>
                    )}
                    {viewingItem.position && (
                      <p>
                        <span className="font-medium">Position:</span>{" "}
                        {viewingItem.position}
                      </p>
                    )}
                    {viewingItem.origin && (
                      <p>
                        <span className="font-medium">Origin:</span>{" "}
                        {viewingItem.origin}
                      </p>
                    )}
                    {viewingItem.category?.name && (
                      <p>
                        <span className="font-medium">Category:</span>{" "}
                        {viewingItem.category.name}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            )}
            <button
              onClick={closeViewModal}
              className="mt-6 bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
            >
              Close
            </button>
          </div>
        </div>
      )}

      <div className="overflow-x-auto">
        <table className="w-full border-collapse text-sm">
          <thead>
            <tr className="bg-gray-200">
              <th className="p-1 text-left">Date</th>
              <th className="p-1 text-left">Brand</th>
              <th className="p-1 text-left">Branch</th>
              <th className="p-1 text-left">Category</th>
              <th className="p-1 text-left">Size</th>
              <th className="p-1 text-left">Unique Size / AMP</th>
              <th className="p-1 text-left">Quantity</th>
              <th className="p-1 text-left">Unit Price</th>
              <th className="p-1 text-left">Total</th>
              <th className="p-1 text-left">Note</th>
              <th className="p-1 text-left">Person</th>
              <th className="p-1 text-left">Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredStockOuts.map((stockOut) => (
              <tr key={stockOut.id} className="border-b hover:bg-gray-50">  {/* FIXED: use stockOut.id */}
                <td className="p-1">
                  {stockOut.created_at
                    ? new Date(stockOut.created_at).toLocaleDateString()
                    : "N/A"}
                </td>
                <td className="p-1">{stockOut.item?.brand || "N/A"}</td>
                <td className="p-1">{stockOut.item?.branch || "N/A"}</td>
                <td className="p-1">
                  {stockOut.item?.category?.name || "N/A"}
                </td>
                <td className="p-1">{stockOut.item?.size || "N/A"}</td>
                <td className="p-1">
                  {stockOut.item?.uniquesize || stockOut.item?.ampere || "N/A"}
                </td>
                <td className="p-1">{stockOut.quantity || 0}</td>
                <td className="p-1">${stockOut.unitprice || 0}</td>
                <td className="p-1">
                  ${(stockOut.quantity * stockOut.unitprice || 0).toFixed(2)}
                </td>
                <td className="p-1">{stockOut.note || "-"}</td>
                <td className="p-1">{stockOut.user?.name || "-"}</td>
                <td className="p-1 flex flex-wrap gap-1">
                  <button
                    onClick={() => handleEdit(stockOut)}
                    disabled={isLoading.edit}
                    className="bg-yellow-500 text-white text-xs px-1.5 py-0.5 rounded hover:bg-yellow-600 disabled:opacity-50"
                  >
                    {isLoading.edit ? "..." : "Edit"}
                  </button>
                  <button
                    onClick={() => handleDelete(stockOut.id)}  // FIXED: use stockOut.id
                    disabled={isLoading.delete}
                    className="bg-red-500 text-white text-xs px-1.5 py-0.5 rounded hover:bg-red-600 disabled:opacity-50"
                  >
                    {isLoading.delete ? "..." : "Delete"}
                  </button>
                  <button
                    onClick={() => openViewModal(stockOut)}
                    className="bg-teal-500 text-white text-xs px-1.5 py-0.5 rounded hover:bg-teal-600"
                  >
                    View
                  </button>
                  <button
                    onClick={() => handleTransfer(stockOut)}
                    disabled={isLoading.transfer}
                    className="bg-green-500 text-white text-xs px-1.5 py-0.5 rounded hover:bg-green-600 disabled:opacity-50"
                  >
                    {isLoading.transfer ? "..." : "Transfer"}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default StockOutPage;